import clsx, { type ClassValue } from 'clsx';

/**
 * Conditional className helper.
 *
 * We deliberately do not use `tailwind-merge` (not a declared dependency);
 * components expose a `className` prop appended last so callers can still
 * override, and conflicting utilities are avoided by construction.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
